export const CORES = [
    '#2E7D32',
    '#1565C0',
    '#EF6C00',
    '#C62828',
    '#6A1B9A',
    '#00838F',
    '#AD1457',
    '#37474F',
];

export const EMOJIS = [
    '🎉', '🚀', '✨', '✅', '⚠️', '❗', '🔔', '📢',
    '💡', '🛠️', '📦', '📊', '📈', '📅', '⏰', '👷',
    '👀', '👍', '👏', '🙌', '💪', '❤️', '⭐', '🥽',
    '🆕', '📌', '📝', '📎', '🧾', '🦺', '⛑️', '🧤',
];